module.exports = __webpack_public_path__ + "static/media/Bitmap.45e0dbdf.png";